var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('zf-card',{staticClass:"pending-switch-banner",attrs:{"background":"secondary"}},[_c('p',{staticClass:"rocket-emoji"},[_vm._v("🚀")]),_c('div',[_c('h3',[_vm._v("Tarifwechsel aktiv")]),_c('div',[_vm._v(" Wir sind gerade dabei deinen Tarif zu "),_c('b',[_vm._v(_vm._s(_vm.newSupplier))]),_vm._v(" zu wechseln. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }